import { useTranslation } from 'react-i18next';

export default function FinalCTASection() {
  const { t } = useTranslation('common');

  return (
    <section className="py-16 md:py-24 bg-secondary-100 relative overflow-hidden">
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20organic%20texture%20with%20flowing%20warm%20olive%20green%20and%20sand%20beige%20shapes%20minimal%20calm%20pattern%20subtle%20depth%20natural%20earthy%20tones%20high%20resolution&width=1600&height=800&seq=cta-bg-v2&orientation=landscape&nocache=true"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
            {t('final.h2')}
          </h2>
          <p className="text-foreground-600 leading-relaxed mb-8 max-w-2xl mx-auto">
            {t('final.desc')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              {t('final.cta')}
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-800 font-semibold text-sm rounded-lg border border-background-200 hover:bg-background-100 transition-all whitespace-nowrap"
            >
              {t('cta.continueMain')}
              <i className="ri-external-link-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}